import { useEffect } from "react";

// The canonical, crawlable Terms of Service is served as a static HTML file at
// /terms.html (so Google's no-JS verification crawler can read it). This route
// simply forwards any in-app or bookmarked /terms visit there.
export default function Terms() {
  useEffect(() => {
    window.location.replace("/terms.html");
  }, []);
  return null;
}
